export const REORDER_PARTIAL_FROM_NAVIGATION_KEY = "da:reorder-partial";

export function shouldRevealReorderPartialPopup(
	pathname: string,
	routeId = "",
): boolean {
	if (routeId.includes("productId")) {
		return false;
	}
	if (routeId.includes("_products")) {
		return true;
	}
	return pathname === "/products" || pathname.startsWith("/products/");
}

let pendingReorderPartial = false;
let revealPartialPopup = false;

export function markReorderPartialFromNavigation(): void {
	pendingReorderPartial = true;
	try {
		sessionStorage.setItem(REORDER_PARTIAL_FROM_NAVIGATION_KEY, "1");
	} catch {
		// sessionStorage can throw in private mode; the in-memory flag is enough
	}
}

export function isReorderPartialFromNavigationPending(): boolean {
	if (pendingReorderPartial) {
		return true;
	}
	try {
		return sessionStorage.getItem(REORDER_PARTIAL_FROM_NAVIGATION_KEY) === "1";
	} catch {
		return false;
	}
}

export function consumeReorderPartialFromNavigation(): boolean {
	if (isReorderPartialFromNavigationPending()) {
		revealPartialPopup = true;
		pendingReorderPartial = false;
		try {
			sessionStorage.removeItem(REORDER_PARTIAL_FROM_NAVIGATION_KEY);
		} catch {
			// ignore
		}
	}
	return revealPartialPopup;
}

export function dismissReorderPartialFromNavigation(): void {
	revealPartialPopup = false;
}

export function clearReorderPartialFromNavigation(): void {
	pendingReorderPartial = false;
	revealPartialPopup = false;
	try {
		sessionStorage.removeItem(REORDER_PARTIAL_FROM_NAVIGATION_KEY);
	} catch {
		// ignore
	}
}
